import React from "react";
import Textarea from "@/components/ui/textarea";
import type { TextareaProps } from "@/types/component";
import styles from "./index.module.scss";

export interface PollTextareaProps
  extends Omit<TextareaProps, "className"> {
  /** Optional className for the root container */
  className?: string;
}

export const PollTextarea: React.FC<PollTextareaProps> = ({
  className,
  variant = "standard",
  rows = 6,
  ...props
}) => (
  <div className={`${styles.root} ${className ?? ""}`}>
    <Textarea variant={variant} rows={rows} {...props} />
  </div>
);

export default PollTextarea;
